export enum LocalStorageKeys {
  GoogleAnalytics = 'ga-enabled',
  CookiePreferenceAcceptVersion = 'cookie-preference-accept-version',
}
